import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../config/AuthProvider.js";
import DropDownMenu from "../../components/shared/menus/DropDownMenu.jsx";

export default function Menu() {
  const { auth, logout, attributes } = useAuth();
  const navigate = useNavigate();
  const displayName = [attributes?.name, attributes?.family_name]
    .filter(Boolean)
    .join(" ");

  const handleAuth = async () => {
    if (attributes) {
      await logout(navigate);
    } else {
      window.location.assign("/IniciarSesion");
    }
  };

  return (
    <header className="bg-sky-400 text-sky-900 shadow-md">
      {/* Contenedor principal */}
      <div className="mx-auto flex flex-wrap items-center justify-between px-4 py-2 md:px-8">
        {/* Contenedor superior: Logo + Texto + DropDown */}
        <div className="flex w-full space-y-2">
          {/* Logo y texto */}
          <div className="flex items-center space-x-3">
            <img src="/AutoresAngeles.jpg" alt="Logo" className="h-16 w-16" />
            <div className="block w-64 md:w-80 lg:w-[400px]">
              <strong className="block text-lg font-bold uppercase">
                Educacion en la fe
              </strong>
              {/* <span className="flex-wrap text-xs italic">
                R.M María Magdalena de la Reparación Vargas Galeana
              </span> */}
            </div>
          </div>

          <div className="flex w-full justify-between">
            {/* Texto centrado (Educación en la fé) */}
            <div className="w-full flex-grow items-center justify-center md:flex">
              {/* <h1 className="mx-8 hidden text-center text-base font-semibold uppercase md:inline md:text-xl">
                Educación en la fe
              </h1> */}
            </div>

            {/* DropDownMenu */}
            <div className="">
              <DropDownMenu
                isAuthenticated={attributes ?? false}
                avatar={attributes?.picture || "/AutoresAngeles.jpg"}
                name={displayName || "Mi cuenta"}
                role={auth}
                menuItems={[
                  {
                    group: "Usuario",
                    label: "Mi cuenta",
                    link: auth === "ADMINS" ? "/admin" : "/user",
                    separator: true,
                    roles: ["USERS", "ADMINS"],
                  },
                  {
                    group: "Usuario",
                    label: "Compras",
                    link: "/user/compras",
                    roles: ["USER"],
                  },
                  {
                    group: "Usuario",
                    label: "Configuraciones",
                    link:
                      auth === "ADMINS"
                        ? "/admin/configuracion"
                        : "/user/configuracion",
                    separator: true,
                    roles: ["USERS", "ADMINS"],
                  },
                  {
                    group: "Administración",
                    label: "Banner",
                    link: "/admin/banner",
                    separator: true,
                    roles: ["ADMINS"],
                  },
                  {
                    group: "Administración",
                    label: "Conferencias",
                    link: "/admin/conferencias",
                    separator: true,
                    roles: ["ADMINS"],
                  },
                  {
                    group: "Administración",
                    label: "Galeria",
                    link: "/admin/galeria",
                    roles: ["ADMINS"],
                  },
                  {
                    group: "Administración",
                    label: "Libros",
                    link: "/admin/libros",
                    roles: ["ADMINS"],
                  },
                  {
                    group: "Administración",
                    label: "Resolución de libros",
                    link: "/admin/resolucion-de-libros",
                    roles: ["ADMINS"],
                  },
                  {
                    group: "Administración",
                    label: "Devocionario",
                    link: "/admin/devocionario",
                    roles: ["ADMINS"],
                  },
                  {
                    group: "Administración",
                    label: "Contacto",
                    link: "/admin/contacto",
                    roles: ["ADMINS"],
                  },
                  {
                    group: "Administración",
                    label: "Noticias",
                    link: "/admin/noticias",
                    roles: ["ADMINS"],
                  },
                  {
                    group: "Administración",
                    label: "Mensaje",
                    link: "/admin/mensaje",
                    roles: ["ADMINS"],
                  },
                  {
                    group: "Sesión",
                    label: "Cerrar sesión",
                    action: handleAuth,
                    separator: true,
                  },
                ]}
                onLogin={handleAuth}
                onNavigate={(link) => navigate(link)}
              />
            </div>
          </div>
        </div>

        {/* Menú inferior: Links */}
        <nav className="mt-2 flex w-full flex-row items-center justify-end space-x-6 border-t-2 border-sky-500 pt-2 text-lg sm:mt-0">
          <Link to="/" className="hover:text-gray-900">
            Inicio
          </Link>
          <Link to="/conferencias" className="hover:text-gray-900">
            Galería de Videos
          </Link>
          <Link to="/galeria" className="hover:text-gray-900">
            Recursos de Apoyo
          </Link>
          <Link to="/devocionario" className="hover:text-gray-900">
            Devocionario
          </Link>
          <Link to="/resolucion-de-libros" className="hover:text-gray-900">
            Resolución de libros
          </Link>
          <Link to="/contacto" className="hover:text-gray-900">
            Contacto
          </Link>
        </nav>
      </div>
    </header>
  );
}
